var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.group.GROUP_TEXT
    ? _c(
        "div",
        { staticClass: "question-group", attrs: { id: "groupInstructions" } },
        [
          !_vm.showInfo
            ? _c("div", [
                !_vm.showInfo
                  ? _c(
                      "button",
                      {
                        staticClass: "pull-right btn",
                        attrs: { "aria-controls": "groupInfo" },
                        on: {
                          click: function($event) {
                            _vm.showInfo = true
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-caret-down",
                          attrs: {
                            "aria-label": "expand question group information"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "hint" }, [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("MAIN_CONTENT.QuestionGroup.message")) +
                      "\n\t\t"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showInfo
            ? _c("div", { attrs: { id: "groupInfo" } }, [
                _c("h4", [_vm._v(_vm._s(_vm.group.GROUP_DESC))]),
                _vm._v(" "),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.group.GROUP_TEXT) }
                }),
                _vm._v(" "),
                _vm.groupText.length > 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn pull-right",
                        on: {
                          click: function($event) {
                            _vm.showInfo = false
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-caret-up",
                          attrs: {
                            "aria-label": "collapse question group information"
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }